import styles from '@components/RadioButton/RadioButtonRow/styles.module.scss';
import Row from '@components/Row';
import Text from '@components/Text';
import { ReactNode } from 'react';

interface Props {
    value: string;
    children?: ReactNode;
    isSelected?: boolean;
    onChange?: (v: string) => void;
    disabled?: boolean;
}

function Radio({
  value, children, isSelected, onChange, disabled,
}: Props) {
  return (<Row fullWidth
                 data-selected={isSelected}
                 justify='space-between'
                 align='center'
               aria-disabled={disabled}
                 className={styles.container}
                 onClick={() => {
                   if (!disabled) {
                     onChange?.(value);
                   }
                 }} >
        <Row spacing={8} fullWidth>
            <div className={`${styles.circleWrapper} ${isSelected && styles.selected}`}>
                <div className={styles.circle} >
                    <div className={styles.dot} />
                </div>
            </div>
            <Text as='div' className={styles.children}>{children}</Text>
        </Row>
    </Row>);
}

export default Radio;
